import React, { useState, useEffect } from 'react';
import styles from './Imprint.styl';
import ProfileStore from '../../../../stores/ProfileStore';
import { translate } from 'react-i18next';
import Page from '../../../containers/Page';
// md3 divider — replaces the fe-ui-core (MUI) <Divider/>; pure token-driven rule, no MUI.
const MDivider = () => (React.createElement("hr", { style: { border: 0, borderTop: '1px solid var(--md-outline-variant)', margin: '12px 0' } }));
const Imprint = ({ t, history }) => {
    const [seller, setSeller] = useState({ imprint: { text: { de: '' } }, termCond: { text: { de: '' } } });
    useEffect(() => {
        async function fetchMyAPI() { setSeller(await ProfileStore.getDealerProfileCheckout(vehicleID)); }
        fetchMyAPI();
        goToSellerDetails(vehicleID);
    }, []);
    const goToSellerDetails = (vehicleID) => {
        history.push(`/seller/${vehicleID}`);
    };
    const vehicleID = window.location.pathname.replace('/seller/', '');
    // const pathname = 'tIJ5hVQjPob3jlM5YLJINRsyRqH2';
    const imprintText = seller.imprint && seller.imprint.text.de;
    const termCond = seller.termCond && seller.termCond.text.de;
    return (React.createElement(Page, { page: 'DEALER_IMPRINT' },
        React.createElement("div", { className: `md3 ${styles.imprintContainer}` },
            React.createElement("span", { className: styles.title }, t('CheckoutPage:modals.sellerImprint.secondTitle')),
            React.createElement(MDivider, null),
            React.createElement("span", { className: `${styles.imprintText} ${styles.termCond}` }, termCond),
            React.createElement("span", { className: styles.imprintTitle }, t('CheckoutPage:modals.sellerImprint.title')),
            React.createElement(MDivider, null),
            React.createElement("span", { className: styles.imprintText }, imprintText))));
};
export default translate(['CheckoutPage'])(Imprint);
